export enum NoteTypes {
  Patient = 1,
  PatientCommunication = 2,
}
